import {
  Dialog,
  Heading,
  Text,
  TextButton,
  TextLink,
} from '@smart/web-components';
import '@smart/web-components/dist/foundation.css';
import React from 'react';
import countries from './countries';
import './styles.css';

export const App = () => {
  const [modalProps, setModalProps] = React.useState({
    open: false,
    link: ``,
  });
  const sortedCountries = countries.sort((a, b) =>
    a.nation.localeCompare(b.nation),
  );

  void import(`./utils/datadog-rum`).then(({setupDatadogBrowserRum}) => {
    setupDatadogBrowserRum();
  });

  return (
    <div className="light-theme">
      <div className="app">
        <div className="header">
          <img
            className="logo"
            src={`/images/logo.svg`}
            alt="smart-vertical-logo"
          />
        </div>
        <div className="teaser"></div>
        <div className="content">
          <Heading className="title" variant="headline-functional-100">
            Select your location
          </Heading>

          <p className="description"></p>

          {sortedCountries.map((country) => {
            return (
              <div className="market-container" key={country.nation}>
                <img
                  className="flag"
                  src={`/images/${country.flag}`}
                  alt={country.nation}
                />
                <div className="country">
                  <Heading
                    className="heading-country"
                    variant="headline-functional-300"
                    tag="h2"
                  >
                    {country.nation}
                  </Heading>
                  <div className="languages">
                    {country.languages.map((language, index) => {
                      return (
                        <TextLink
                          key={`${language.title}-${index}`}
                          className="text-link"
                          variant="hyperlink-100"
                          href={language.url}
                          title={language.title}
                        >
                          {language?.name}
                        </TextLink>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="footer">
          <div className="footer-logo-container">
            <img
              className="logo-text"
              src={`/images/logo-text.svg`}
              alt="smart-text-logo"
            />
          </div>
          <div className="links-container">
            <TextLink
              className="footer-link"
              variant="hyperlink-standalone"
              href="https://media.smart.com/eu"
            >
              Media
            </TextLink>
            <TextLink
              className="footer-link"
              variant="hyperlink-standalone"
              href="https://career.smart.com"
            >
              Careers
            </TextLink>
            <TextLink
              className="footer-link"
              variant="hyperlink-standalone"
              href="https://media.smart.com/eu/imprint-eu1"
            >
              Imprint
            </TextLink>
          </div>
          <div className="divider-container">
            <span className="divider"> </span>
          </div>
          <div className="socials-container">
            <p className="copyright">© 2026 smart Europe GmbH</p>
          </div>
        </div>
      </div>
      <Dialog
        isOpen={modalProps.open}
        outsideClick={() => setModalProps({open: false, link: ``})}
        ariaDescription="Your are now leaving this site"
        text="You are about to leave this site. You will be redirected to an external site. Terms and conditions and privacy policy might differ. Would you really like to leave this page?"
        headline={{tag: `h1`, children: `Your are now leaving this site`}}
        buttons={
          <>
            <div style={{margin: `0.5em`}}>
              <TextButton
                variant="secondary"
                onClick={() => setModalProps({open: false, link: ``})}
              >
                Stay here
              </TextButton>
            </div>
            <div style={{margin: `0.5em`}}>
              <TextLink variant="button-primary" href={modalProps.link}>
                Leave this page
              </TextLink>
            </div>
          </>
        }
      />
    </div>
  );
};
